import { Injectable } from '@angular/core';
import { vignetteOpe } from 'src/app/models/vignetteOpe';





@Injectable()
export class PersistanceService {



// Permet de contourner le probleme d'actualisation des données 
 // Todo 
 /**
  */
  constructor() { }

  set(key: string, data: any): void {
    try {
      localStorage.setItem(key, JSON.stringify(data));
    } catch (e) {
      console.error('Error saving to localStorage', e);
    }
  }

  get(key: string): vignetteOpe {
    try {
      
      return JSON.parse(localStorage.getItem(key) || '{}');

    } catch (e) {
      console.error('Error getting data from localStorage', e);
      return JSON.parse('{}');
    }
  }

  clear(){
    localStorage.clear();
  }
}